export default __webpack_public_path__ + "static/assets/med_x_pipette.ac350d08.png";